import gql from 'graphql-tag';


export const ALLTIENDAS = gql`
  query todasTiendas($idUser:Int!){
    tiendas(idUser:$idUser){
      id
      idDB
      nombre
      categoria
      locacion
      negocio
      activo
      horario
    }
  }
`;


export const TIENDA = gql`
  query getTienda($id:Int!, $idUser:Int!){
    tienda(id:$id, idUser:$idUser){
      id
      idDB
      nombre
      categoria
      locacion
      negocio
      activo
      horario
    }
  }
`;

export const UPDATETIENDA = gql`
  mutation updateTienda($id:Int!, $nombre:String, $categoria:String, $locacion:String, $negocio:String, $activo:Int, $horario:String){
    tiendaUpdate(id:$id, tienda:{
      nombre:$nombre,
      categoria:$categoria,
      locacion:$locacion,
      negocio:$negocio
      activo:$activo
      horario:$horario
    }){
      id
    }
  }
`;
